import { isFieldDeclaration } from '../model/field-declaration';
import { FormDeclaration } from '../model/form-declaration';

/**
 * Transforms the given `value` into a templated string
 * if `value` can be resolved to a campaign field.
 *
 * @param value Some value that may represent a field key
 * @param declaration Form declaration
 *
 * @returns
 * If `value` references a key of a field, it will be
 * transformed to `{{value}}`.
 * If not, it will return the given `value`.
 */
export function ensureTemplate(
  value: string,
  declaration: FormDeclaration,
): string {
  const otherField = declaration.findByKey(value, isFieldDeclaration);
  if (otherField) {
    return `{{${value}}}`;
  }

  return value;
}
